'use client';

import React, { useRef, useState } from 'react';

import { ScanQRCode } from '@depop/web-thrift-ui/Icons/ScanQRCode';
import { QrCodeIcon } from '@depop/web-ui-kit/Icons/QrCodeIcon';
import { Modal } from '@depop/web-ui-kit/Modal';
import { clsx } from 'clsx';
import { QRCodeCanvas } from 'qrcode.react';

import styles from '@/app/[locale]/shop/[username]/(shop)/components/ShopProducts/styles.module.css';
import { ButtonExperiment } from '@/components/ButtonExperiment';
import { useBranchDeepLink } from '@/modules/externalTracking/useBranchDeepLink.ts';
import { useCurrentUser } from '@/modules/user/useCurrentUser.ts';

export function ShopQRCodeModalButton() {
  const [, user] = useCurrentUser();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const shopUrl = `https://depop.com/${user?.username}?utm_content=${user?.username}`;

  const deepLink = useBranchDeepLink({
    fallback: shopUrl,
    appPath: user ? `/user/${user.username}` : '',
    feature: 'community',
    channel: 'General',
    campaign: 'COMMUNITY_GEN_GLOBAL_ACQ_ALLP_ALL_QRCODE',
  });

  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  function handleDownload() {
    if (!canvasRef.current) {
      return;
    }

    const canvas = canvasRef.current;
    const pngUrl = canvas.toDataURL('image/png');

    const link = document.createElement('a');
    link.href = pngUrl;
    link.download = `qr-${user?.username || 'code'}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <>
      <ButtonExperiment
        variant="tertiary"
        legacyOutline={false}
        onClick={() => setIsModalOpen(true)}
        legacyClassName={clsx(
          styles.actionButton,
          styles.rearrangeModeActiveButton
        )}
        icon={<ScanQRCode size="md" />}
        legacyIcon={<QrCodeIcon size={18} />}
      >
        Shop QR Code
      </ButtonExperiment>
      <Modal
        isOpen={isModalOpen}
        setOpen={setIsModalOpen}
        content={() => (
          <div className={styles.qrModalContainer}>
            <QRCodeCanvas
              ref={canvasRef}
              value={deepLink}
              size={256}
              imageSettings={{
                src: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/sellerOnboarding/sticker-smile@2x.png`,
                crossOrigin: 'anonymous',
                x: undefined,
                y: undefined,
                height: 50,
                width: 50,
                opacity: 1,
                excavate: true,
              }}
            />
            <ButtonExperiment
              legacyClassName={styles.qrModalDownloadButton}
              onClick={handleDownload}
            >
              Download QR Code
            </ButtonExperiment>
          </div>
        )}
        title={`QR Code for ${user?.username}`}
      />
    </>
  );
}
